module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/mailing-list/component/history-mailing-page/history-mailing-page.component.sass
// module id = ./src/app/modules/mailing-list/component/history-mailing-page/history-mailing-page.component.sass
// module chunks = main